import React, { useRef } from 'react';
import '@/App.css';
import Navigation from './sections/Navigation';
import HeroSection from './sections/HeroSection';
import FeaturesSection from './sections/FeaturesSection';
import HowItWorks from './sections/HowItWorks';
import TestimonialsSection from './sections/TestimonialsSection';
import FAQSection from './sections/FAQSection';
import ContactSection from './sections/ContactSection';
import FooterSection from './sections/FooterSection';
import useVapiWidget from './hooks/useVapiWidget';

function App() {
  const contactRef = useRef(null);
  useVapiWidget();

  const scrollToContact = () => {
    const contactEl = document.getElementById('contact');
    if (contactEl) {
      contactEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="noise-overlay min-h-screen bg-[#050505]" data-testid="app-root">
      <Navigation onScheduleCall={scrollToContact} />
      <HeroSection onBookDemo={scrollToContact} />
      <FeaturesSection />
      <HowItWorks />
      <TestimonialsSection />
      <FAQSection />
      <ContactSection ref={contactRef} />
      <FooterSection />
    </div>
  );
}

export default App;
